import {ButtonSecondary} from "@/Components/Buttons/ButtonSecondary";
import i18n from "i18next";
import {getCookie, setCookie} from "@/Utilities/CookieManager";

export default function AddAndRemoveButtons({bundle, disabled, state, dispatch}) {

    const handleOnClick = (bundle, addRemove) => {
        let newValue = [];
        const cartCookie = 'cartProducts';
        const currentCart = getCookie(cartCookie);

        if (addRemove === "addToCart") {
            newValue = (typeof currentCart === "undefined") ? [bundle.productId] : [...currentCart, bundle.productId];
            dispatch({ type: "addToCart", payload: { addToCart: bundle }});
        } else {
            if (typeof currentCart !== "undefined") {
                newValue = currentCart.filter(item => item !== bundle.productId);
            }
            dispatch({ type: "removeFromCart", payload: { removeFromCart: bundle }})
        }

        setCookie(cartCookie, newValue, 3);
        dispatch({ type: "cookies", payload: { cookies: getCookie(cartCookie) }});
    }

    return (
        <div>
            {!state.cart.includes(bundle) ?
                <ButtonSecondary
                    disabled={disabled}
                    dataQa={`${bundle.name.toLowerCase().replace(' ', '-')}-add-button`}
                    onClick={() => handleOnClick(bundle, "addToCart")}
                >
                    <i className="far fa-plus"/>
                    {i18n.t("buy-flow.add-to-cart")}
                </ButtonSecondary> :
                <div>
                    <ButtonSecondary
                        className="remove-button"
                        dataQa={`${bundle.name.toLowerCase().replace(' ', '-')}-remove-button`}
                        onClick={() => handleOnClick(bundle, "removeFromCart")}
                    >
                        {i18n.t("buy-flow.remove")}
                    </ButtonSecondary>
                    <span className="add-confirmed">
                        <i className="far fa-check"/>
                        <span>{i18n.t("buy-flow.added")}</span>
                    </span>
                </div>
            }
        </div>
    )
}
